import React from 'react';
import { connect } from 'react-redux';

import Statistics from './Statistics';

export const StatisticsWrapper = ({ activityTypes }) => {
  if (activityTypes.length) {
    return <Statistics activityTypes={activityTypes} />;
  }

  return null;
};

const mapStateToProps = ({ admin: { activities: { list } } }) => ({
  activityTypes: list,
});

export default connect(mapStateToProps, null)(StatisticsWrapper);



// WEBPACK FOOTER //
// ./src/components/Statistics/index.js